<template>
  <ion-page>
    <master-layout pageTitle="مشتریان مأموریت">
      <div id="map3"></div>
        <ion-card-content v-if="mission">
          <div class="mb-1">
            {{mission.title}}
            &nbsp;ـــــــ&nbsp;{{mission.mission_number}}
          </div>
          <div class="d-flex-between">
            <div class="marker-note">
              <img src="/assets/img/order-marker.png">&nbsp;
              <p>موفق</p>
            </div>
            <div class="marker-note">
              <img src="/assets/img/reject-marker.png">&nbsp;
              <p>نا موفق</p>
            </div>
            <div class="marker-note">
              <img src="/assets/img/no-visit-marker.png">&nbsp;
              <p>انجام نشده</p>
            </div>
          </div>
        </ion-card-content>
    </master-layout>
  </ion-page>
</template>

<script>
import L from "leaflet";
require('leaflet.locatecontrol');
import {mapActions} from "vuex";
import {IonPage,IonCardContent} from '@ionic/vue';
export default {
name: "view",
  components: { IonPage,IonCardContent},
  data()
  {
    return{
      id: null,
      mission: null,
      mission_items: [],
      map: null,
      markers: null,
    }

  },
  mounted()
  {
    this.init();
  },
  methods: {
    async init()
    {
      const self = this;
      this.id = this.$route.params.id;
      const result = await this.getMission(this.id);
      if(result.ok)
      {
        this.mission = result.mission;
        this.mission_items = result.items;

        setTimeout(function (){
          self.initMap();

          const places = result.items;
          for (let i = 0; i < places.length; i++)
          {
            if (places[i].location && places[i].location.coordinates && places[i].location.coordinates[0] && places[i].location.coordinates[1])
            {
              let iconUrl = '';

              // if(places[i].is_visit && places[i].reason_ids)
              //   iconUrl = '/assets/img/reject-marker.png';
              // if(places[i].is_visit && places[i].order_id)
              //   iconUrl = '/assets/img/order-marker.png';
              if(!places[i].is_visit)
                iconUrl = '/assets/img/no-visit-marker.png';
              else if (places[i].is_visit && result === 1)
                iconUrl = '/assets/img/order-marker.png';
              else if (places[i].is_visit && result === 0)
                iconUrl = '/assets/img/reject-marker.png';




              self.placeMarker({
                latlng: {
                  lat:places[i].location.coordinates[1],
                  lng:places[i].location.coordinates[0],
                }
              },places[i]._id,iconUrl)
            }
          }


        },1000)
      }
    },
    ...mapActions('mission',{
      getMission:'getMission',
    }),
    initMap()
    {
      if (this.map)
      {
        return;
      }
      var lat = 36.288376;
      var lng = 59.572325;
      if (this.mission_items[0] && this.mission_items[0].location.coordinates)
       lat=this.mission_items[0].location.coordinates[1] , lng= this.mission_items[0].location.coordinates[0];
      var zoom=12;
      var osmUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
          osmAttrib = '&copy; <a href="https://carencar.com">کارن کار</a>',
          osm = L.tileLayer(osmUrl, {maxZoom: 18, attribution: osmAttrib});
      this.map = L.map('map3',{ zoomControl: true, dragging: true, boxZoom: true, scrollWheelZoom: true }).setView([lat,lng], zoom).addLayer(osm);
      L.control.locate({
        drawCircle: true, // controls whether a circle is drawn that shows the uncertainty about the location
        setView: true, // automatically sets the map view to the user's location, enabled if follow is true
        follow:true,
        flyTo:true,
        keepCurrentZoomLevel: false, // keep the current map zoom level when displaying the user's location. (if false, use maxZoom)
        circlePadding: [0, 0], // padding around accuracy circle, value is passed to setBounds
        locateOptions: {
          maxZoom: 15
        },
        strings: {
          title: "نمایش موقعیت فعلی", // title of the locate control
          popup: "موقعیت فعلی شما", // text to appear if user clicks on circle
          outsideMapBoundsMsg: "بنظر میاد شما در خارج از این کره خاکی هستید" // default message for onLocationOutsideMapBounds
        }
      }).addTo(this.map);
      // L.Control.geocoder().addTo(this.map);


    },
    placeMarker(e,id,iconUrl)
    {
      const self = this;

      const markerIcon = new L.Icon({
        iconUrl: iconUrl,
        iconSize:     [30, 46],
      });
      this.markerHolder = new L.marker(e.latlng,{icon:markerIcon})
      this.markerHolder.on('click', function ()
      {
        self.$router.push({path : '/DeliverMissions/itemId/'+id})
      });
      this.markerHolder.addTo(this.map);
      this.lat = e.latlng.lat;
      this.lng = e.latlng.lng;

    },
  },
}

</script>

<style scoped>
#map3 {
  height: 400px;
  direction: ltr;
}
.marker-note-box {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
}
.marker-note {
  display: flex;
  margin-bottom: 5px;
}
.marker-note p {
  font-size: 13px;
}
.marker-note img {
  width: 15px;
}
.d-flex-between
{
  display: flex;
  justify-content: space-between;
}
.mb-1
{
  margin-bottom: 7px;
}
</style>